// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table{margin-top:1rem}tr{margin-bottom:10px;vertical-align:baseline}td:first-child{min-width:7rem;font-weight:700}td:last-child{width:50%}@media(max-width:992px){table,table :not(a){display:block}td:last-child{font-style:italic;width:100%;font-size:.9em}}", ""]);
// Exports
module.exports = exports;
